(function () {
  'use strict';

  function start() {
    var header = document.querySelector('.uso-compact-header');
    if (!header || header.dataset.usoCompactBound === 'true') return;
    header.dataset.usoCompactBound = 'true';
    var cartToggle = document.querySelector('.uso-compact-header #cartToggle');
    var cartDropdown = document.querySelector('.uso-compact-header #dropdown-cart');
    if (cartToggle && cartDropdown) {
      function syncCartExpanded() {
        var expanded = !cartDropdown.hidden && window.getComputedStyle(cartDropdown).display !== 'none';
        cartToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
      cartToggle.addEventListener('click', function (event) {
        if (event.detail === 0 && window.dropdowncart_type !== 'click' && !('ontouchstart' in document) && window.jQuery) {
          window.jQuery(cartDropdown).stop(true, true).slideToggle('fast');
        }
      });
      var cartObserver = new MutationObserver(syncCartExpanded);
      cartObserver.observe(cartDropdown, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      syncCartExpanded();
    }

    var slot = document.querySelector('.uso-compact-header .uso-rewards-slot');
    if (!slot || !document.body) return;

    var fallback = slot.querySelector('.uso-rewards-fallback');
    var fallbackLabel = slot.querySelector('.uso-rewards-fallback-label');
    var status = slot.querySelector('.uso-rewards-status');
    var defaultLabel = fallbackLabel ? fallbackLabel.textContent : '';
    var prepared = new WeakSet();
    var activeLauncher = null;
    var pending = false;
    var deadline = 0;
    var timer = null;
    var activationVersion = 0;

    function setFallbackState(state) {
      slot.setAttribute('data-rewards-state', state);
      if (!fallback) return;
      var loading = state === 'loading';
      fallback.setAttribute('aria-busy', loading ? 'true' : 'false');
      fallback.setAttribute('aria-disabled', loading ? 'true' : 'false');
      if (fallbackLabel) {
        fallbackLabel.textContent = loading ? fallback.dataset.loadingLabel : state === 'failed' ? fallback.dataset.retryLabel : defaultLabel;
      }
      if (status) {
        status.textContent = loading ? fallback.dataset.loadingStatus : state === 'failed' ? fallback.dataset.unavailableStatus : '';
      }
    }

    function cancelPending(state) {
      pending = false;
      activationVersion += 1;
      window.clearTimeout(timer);
      timer = null;
      setFallbackState(state || 'idle');
    }

    function launcherVisible(launcher) {
      if (!launcher || !launcher.isConnected || launcher.hidden) return false;
      var style = window.getComputedStyle(launcher);
      return style.display !== 'none' && style.visibility === 'visible' && (style.opacity === '' || Number(style.opacity) !== 0);
    }

    function flushPending() {
      if (!pending) return;
      if (Date.now() >= deadline) {
        cancelPending(launcherVisible(activeLauncher) ? 'idle' : 'failed');
        return;
      }
      if (document.visibilityState === 'hidden' || window.innerWidth > 767 || !launcherVisible(activeLauncher)) return;
      pending = false;
      window.clearTimeout(timer);
      timer = null;
      var version = activationVersion;
      window.requestAnimationFrame(function () {
        if (version !== activationVersion || Date.now() >= deadline || document.visibilityState === 'hidden' || window.innerWidth > 767 || !launcherVisible(activeLauncher)) return;
        activeLauncher.click();
      });
    }

    function prepareLauncher(launcher) {
      if (prepared.has(launcher)) return;
      prepared.add(launcher);
      if (launcher.matches('button, a[href], input, select, textarea')) return;
      if (!launcher.hasAttribute('role')) launcher.setAttribute('role', 'button');
      if (!launcher.hasAttribute('tabindex')) launcher.setAttribute('tabindex', '0');
      if (launcher.getAttribute('role') !== 'button') return;
      var spacePressed = false;
      launcher.addEventListener('keydown', function (event) {
        if (event.target !== launcher || event.defaultPrevented) return;
        if (event.key === 'Enter') {
          event.preventDefault();
          if (!event.repeat) launcher.click();
        } else if (event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          spacePressed = true;
        }
      });
      launcher.addEventListener('keyup', function (event) {
        if (event.target !== launcher) return;
        if (event.key === ' ' || event.key === 'Spacebar') {
          var activate = spacePressed && !event.defaultPrevented;
          spacePressed = false;
          event.preventDefault();
          if (activate) launcher.click();
        }
      });
      launcher.addEventListener('blur', function () {
        spacePressed = false;
      });
    }

    function syncAvailability() {
      var ready = launcherVisible(activeLauncher);
      var wasFocused = fallback && document.activeElement === fallback;
      slot.classList.toggle('uso-rewards-native-ready', ready);
      if (fallback) fallback.hidden = ready;
      if (ready) {
        setFallbackState('idle');
        if (wasFocused) activeLauncher.focus({ preventScroll: true });
        flushPending();
      }
    }

    var nativeObserver = new MutationObserver(syncAvailability);

    function moveLaunchers() {
      if (!slot.isConnected) return;
      var incoming = document.querySelectorAll('body > .swell-tab');
      for (var index = 0; index < incoming.length; index += 1) {
        prepareLauncher(incoming[index]);
        slot.appendChild(incoming[index]);
      }
      var nativeLaunchers = slot.querySelectorAll(':scope > .swell-tab');
      var nextLauncher = incoming.length ? incoming[incoming.length - 1] : activeLauncher;
      if (!nextLauncher || nextLauncher.parentElement !== slot) {
        nextLauncher = nativeLaunchers.length ? nativeLaunchers[nativeLaunchers.length - 1] : null;
      }
      for (var item = 0; item < nativeLaunchers.length; item += 1) {
        prepareLauncher(nativeLaunchers[item]);
        nativeLaunchers[item].classList.toggle('uso-rewards-duplicate', nativeLaunchers[item] !== nextLauncher);
      }
      if (activeLauncher !== nextLauncher) {
        nativeObserver.disconnect();
        activeLauncher = nextLauncher;
        if (activeLauncher) nativeObserver.observe(activeLauncher, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      }
      syncAvailability();
    }

    if (fallback) {
      fallback.addEventListener('click', function () {
        if (pending || window.innerWidth > 767) return;
        var failed = slot.getAttribute('data-rewards-state') === 'failed';
        moveLaunchers();
        if (launcherVisible(activeLauncher)) {
          activeLauncher.click();
          return;
        }
        if (failed) {
          window.location.reload();
          return;
        }
        pending = true;
        deadline = Date.now() + 30000;
        activationVersion += 1;
        setFallbackState('loading');
        timer = window.setTimeout(function () {
          if (pending) cancelPending('failed');
        }, 30000);
        moveLaunchers();
      });
    }

    var observer = new MutationObserver(function (mutations) {
      for (var index = 0; index < mutations.length; index += 1) {
        if (mutations[index].addedNodes.length || mutations[index].removedNodes.length) {
          moveLaunchers();
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true });
    var slotObserver = new MutationObserver(moveLaunchers);
    slotObserver.observe(slot, { childList: true });
    document.addEventListener('shopify:section:load', moveLaunchers);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'hidden') moveLaunchers();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 767) cancelPending('idle');
    });
    window.addEventListener('pagehide', function () {
      cancelPending('idle');
    });
    window.addEventListener('pageshow', function () {
      moveLaunchers();
    });
    moveLaunchers();

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());

